import { Appointment } from '../../providers/api/dtos/appointment';
import { SortOrder } from '../../providers/pagination';

export function getSortedAppointments(appointments: Appointment[], sort: SortOrder = SortOrder.DESC) {
  const temp = appointments.slice().sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

  return (sort === SortOrder.DESC) ? temp : temp.reverse();
}
